import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";
import {GraphOptionsBuilder} from "../../lq_js_common/e_charts/chart_builder";
import {MinMaxSeries} from "../../lq_js_common/e_charts/min_max_median_series";
import {createBoundedAxisTooltip, formatMillisecondsAxis, formatTimeTick} from "../../helpers/chart_common";

export class ShaperSiteRtt extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
    }

    title() {
        return "Site Round-Trip Time";
    }

    supportsZoom() {
        return true;
    }

    tooltip() {
        return "<h5>Site Round-Trip Time</h5><p>Shows the average round-trip time for the site in the selected time period.</p>";
    }

    buildContainer() {
        let base = super.buildContainer();
        base.appendChild(this.graphDiv());
        return base;
    }

    setup() {
        super.setup();
        this.graph = new ShaperSiteRttGraph(this.graphDivId());
        if (this.lastGraphState !== null) {
            this.graph.update(this.lastGraphState);
        }
    }

    channelRequests() {
        return [ "SiteDetail" ];
    }

    onMessage(msg) {
        if (msg.Data.target !== "site_detail") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }
        for (const [key, value] of Object.entries(msg.Data.blob[0])) {
            this.graph.update(value);
            this.lastGraphState = value;
        }
    }

}

class ShaperSiteRttGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = new GraphOptionsBuilder()
            .withLeftGridSize(75)
            .withTimeAxis()
            .withEmptyLegend()
            .withEmptySeries()
            .build();
        this.option.yAxis = {
            type: "value",
            name: "RTT (ms)",
            nameLocation: "middle",
            nameGap: 50,
            axisLabel: {
                formatter: formatMillisecondsAxis,
            },
        };
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();

        this.option.series = [];
        this.option.xAxis.data = [];
        this.option.legend = { show: false, data: [] };


        // Add series for each shaper
        let d = new MinMaxSeries("RTT", 0);
        for (let x=0; x<data.body.active_circuits.length; x++) {
            this.option.xAxis.data.push(data.body.ticks[x]);
            d.pushPositive(
                data.body.median_rtt_median[x]/10,
                data.body.median_rtt_min[x]/10,
                data.body.median_rtt_max[x]/10,
            )
        }
        d.addToOptions(this.option);

        this.option.tooltip = createBoundedAxisTooltip({
            yFormatter: formatMillisecondsAxis,
            formatter: (params) => {
                if (!params || params.length === 0) return "";
                const timeIndex = params[0].dataIndex;
                return `<div style="font-size: 10px;">
${formatTimeTick(params[0].axisValue)}<br/>
<strong>Round-trip time</strong><br/>
&nbsp;&nbsp;Min: ${formatMillisecondsAxis(data.body.median_rtt_min[timeIndex] / 10)}<br/>
&nbsp;&nbsp;Median: ${formatMillisecondsAxis(data.body.median_rtt_median[timeIndex] / 10)}<br/>
&nbsp;&nbsp;Max: ${formatMillisecondsAxis(data.body.median_rtt_max[timeIndex] / 10)}
</div>`;
            },
        });

        this.chart.setOption(this.option, true);
    }
}
